import * as React from "react";
import { Box, Button, Typography } from "@mui/material";

export default function NewspaperIndex({ question, onAnswer = () => {} }) {
  const hotspots = question.display.elements[0].hotspots || [];
  const [selectedHotspot, setSelectedHotspot] = React.useState(null);

  const handleSetAnswer = (hotspot) => {
    setSelectedHotspot(hotspot);
    onAnswer({
      canProceed: true,
      answer: hotspot.id,
    });
  };

  return (
    <React.Fragment>
      {/* {question.questionText && (
        <Box
          sx={{
            width: "100%",
            background: "white",
            pb: 2,
            pt: 1,
            px: 1,
            border: "1px solid black",
          }}
          className="text-container"
        >
          <Typography variant="h6">{question.questionText}</Typography>
        </Box>
      )} */}
      <Box
        sx={{
          mt: 2,
          mx: 1.25,
          backgroundColor: "lightgray",
          border: "2px solid black",
          borderBottom: "1px solid black",
          padding: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Contents</Typography>
      </Box>
      <Box className="choices-container" sx={{ width: "100%", pt: 0 }}>
        {hotspots.map((hotspot, i) => (
          <Box
            key={`hotspot-${i}`}
            sx={{
              mx: 1.25,
              backgroundColor: i % 2 === 0 ? "gray" : "lightgray",
              border: "1px solid black",
              "&:not(:last-child)": {
                borderBottom: "none",
              },
            }}
          >
            <Button
              variant={
                selectedHotspot?.id === hotspot.id ? "contained" : "outlined"
              }
              fullWidth
              size="large"
              sx={{
                fontSize: "1.2rem",
                lineHeight: "1.2em",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 0,
                margin: 0,
                padding: 2,
                color: "black",
                border: "1px solid black",
              }}
              onClick={() => handleSetAnswer(hotspot)}
            >
              <span>{hotspot.id}</span>
              <span>{hotspot.page}</span>
            </Button>
          </Box>
        ))}
      </Box>
    </React.Fragment>
  );
}
